import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconStar: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.3777 17.6313L8.44507 20.6339C8.25022 20.7933 8.03764 20.8685 7.80735 20.8592C7.57706 20.8507 7.37335 20.7845 7.1962 20.6605C7.01906 20.5365 6.88195 20.3682 6.78487 20.1556C6.68709 19.9431 6.68248 19.7128 6.77105 19.4648L8.28564 14.549L4.43274 11.8121C4.22017 11.6704 4.08731 11.4844 4.03416 11.2541C3.98102 11.0238 3.98988 10.8112 4.06074 10.6164C4.13159 10.4215 4.25559 10.2486 4.43274 10.0977C4.60988 9.94747 4.82246 9.87236 5.07046 9.87236H9.82681L11.368 4.77058C11.4565 4.52258 11.594 4.33197 11.7804 4.19876C11.966 4.06625 12.1651 4 12.3777 4C12.5903 4 12.7894 4.06625 12.975 4.19876C13.1614 4.33197 13.2988 4.52258 13.3874 4.77058L14.9286 9.87236H19.6849C19.9329 9.87236 20.1455 9.94747 20.3226 10.0977C20.4998 10.2486 20.6238 10.4215 20.6947 10.6164C20.7655 10.8112 20.7744 11.0238 20.7212 11.2541C20.6681 11.4844 20.5352 11.6704 20.3226 11.8121L16.4697 14.549L17.9843 19.4648C18.0729 19.7128 18.0687 19.9431 17.9716 20.1556C17.8738 20.3682 17.7363 20.5365 17.5592 20.6605C17.382 20.7845 17.1783 20.8507 16.948 20.8592C16.7177 20.8685 16.5052 20.7933 16.3103 20.6339L12.3777 17.6313Z',
    })
  )
}
